import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { Injectable } from '@angular/core';

@Injectable()
export class OrganizationSettingsVatCodeLineDialogStore extends ComponentStoreV2Factory {
}
